<div class="notification-bar" *ngIf="isDisplay">
  <p class="notification-bar__message">{{ notificationMessage.item.contents }}</p>
  <button class="notification-bar__close" (click)="isDisplay=false">
    <span class="k-icon k-i-close"></span>
  </button>
</div>